
















































































































































































































































import {
  ETemplateType,
  ITemplate,
  EBatchTemplateFilterPeriod,
  EBatchTemplateFilterType,
  IBatchTemplate,
  IPayerType,
  EUserPermissions,
  Dictionary,
  ETemplateLevel,
  ESortOrder,
  isString,
} from '@zunta/configurations'
import Vue from 'vue'
import Component from 'vue-class-component'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import Switcher from '@/components/Switcher.vue'
import Editable from '@/components/inputsV2/Editable.vue'
import RadioGroup from '@/components/RadioGroup.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import UploadLetterModal from '@/views/app/management/settings/pages/facility/batch/components/UploadLetterModal.vue'
import { getSelectContentLabel } from '@/utils/helpers'
import Icon from '@/components/Icon.vue'
import { TemplateModule } from '@/store/modules/template.module'
import { getModule } from 'vuex-module-decorators'
import Api from '@/api'
import { User } from '@/classes/User'
import FileInput from '@/components/inputs/FileInput.vue'
import { ChainModule } from '@/store/modules/chain.module'

@Component({
  components: {
    Editable,
    MultiSelectV2,
    Switcher,
    SelectV2,
    InputV2,
    RadioGroup,
    Icon,
    UploadLetterModal,
    FileInput,
  },
  props: {
    templateProp: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    templatesLength: {
      type: Number,
      required: true,
    },
    formDisabled: {
      type: Boolean,
      default: false,
    },
    payerTypes: {
      type: Array,
      required: true,
    },
    showUploadPdfModal: {
      type: Number,
      default: -1,
    },
    isCreateMailingBatch: {
      type: Boolean,
      default: false,
    }
  },
})
export default class BatchFormTemplate extends Vue {
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  ADD_LETTER_TRIGGER_VALUE: string = ETemplateType.LETTER_PDF
  ADD_MESSAGE_TRIGGER_VALUE: string = ETemplateType.MESSAGE
  EBatchTemplateFilterType = EBatchTemplateFilterType
  EBatchTemplateFilterPeriod = EBatchTemplateFilterPeriod
  ETemplateType = ETemplateType
  getSelectContentLabel = getSelectContentLabel
  user = Api.getUser() as User
  template = {} as IBatchTemplate
  showAllTemplatePayers = false
  isLoadingFile = false

  get batchData () {
    return this.$props.batchData
  }

  get templateType () {
    return this.$props.templateProp.type
  }

  get templatesList () {
    return this.$store.state.template.templates as ITemplate[]
  }

  get messagesList () {
    return this.templatesList.filter(
      (template: ITemplate) => template.type === ETemplateType.MESSAGE
    )
  }

  get lettersList () {
    return this.templatesList.filter(
      (t) =>
        t.type === ETemplateType.LETTER_PDF || t.type === ETemplateType.LETTER
    )
  }

  get templateTypeDisplay () {
    if (this.templateType === ETemplateType.MESSAGE) {
      return 'Message'
    } else {
      return 'Letter'
    }
  }

  get templateTypeDisplayLowerCase () {
    return this.templateTypeDisplay.toLowerCase()
  }

  get templateFilterTypeDisplay () {
    switch (this.template.filterType) {
      case EBatchTemplateFilterType.BALANCES:
        return 'Balances'
      case EBatchTemplateFilterType.TRANSACTIONS:
      default:
        return 'Transactions'
    }
  }

  get templateFilterTypeDisplayLowerCase () {
    return this.templateFilterTypeDisplay.toLowerCase()
  }

  get payerTypesForTemplatesOptions () {
    return this.$props.payerTypes.map((payer: IPayerType) => {
      return {
        key: Number(payer.id as number),
        value: Number(payer.id as number),
        content: payer.payer_name,
      }
    })
  }

  get activePayerTypesIds () {
    return this.$props.payerTypes.map((pt: IPayerType) => pt.id)
  }

  get templateFilterTypeOptions () {
    return [
      {
        key: EBatchTemplateFilterType.NONE,
        value: EBatchTemplateFilterType.NONE,
        content: 'Always Show',
        tooltip: `When selected, the ${this.templateTypeDisplayLowerCase} will be included on all statements regardless of balance or transaction history.`,
      },
      {
        key: EBatchTemplateFilterType.BALANCES,
        value: EBatchTemplateFilterType.BALANCES,
        content: 'Resident has Open Balance',
        tooltip: `When selected, the ${this.templateTypeDisplayLowerCase} will only be included if the resident has an open balance for the selected period and payers.`,
      },
      {
        key: EBatchTemplateFilterType.TRANSACTIONS,
        value: EBatchTemplateFilterType.TRANSACTIONS,
        content: 'Resident has Transactions',
        tooltip: `When selected, the ${this.templateTypeDisplayLowerCase} will only be included if the resident has transactions (regardless of balance) for the selected period and payers.`,
      },
    ]
  }

  get templateFilterPeriods () {
    return {
      [EBatchTemplateFilterPeriod.PREBILL]: {
        key: EBatchTemplateFilterPeriod.PREBILL,
        value: EBatchTemplateFilterPeriod.PREBILL,
        content: 'Pre-bill Month',
      },
      [EBatchTemplateFilterPeriod.CURRENT]: {
        key: EBatchTemplateFilterPeriod.CURRENT,
        value: EBatchTemplateFilterPeriod.CURRENT,
        content: 'Current Month',
      },
      [EBatchTemplateFilterPeriod.PREVIOUS_MONTHS]: {
        key: EBatchTemplateFilterPeriod.PREVIOUS_MONTHS,
        value: EBatchTemplateFilterPeriod.PREVIOUS_MONTHS,
        content: 'Previous Months',
      },
    }
  }

  get templateFilterPeriodOptionsByType () {
    return {
      [EBatchTemplateFilterType.NONE]: [],
      [EBatchTemplateFilterType.BALANCES]: [
        this.templateFilterPeriods[EBatchTemplateFilterPeriod.PREBILL],
        this.templateFilterPeriods[EBatchTemplateFilterPeriod.CURRENT],
        this.templateFilterPeriods[EBatchTemplateFilterPeriod.PREVIOUS_MONTHS],
      ],
      [EBatchTemplateFilterType.TRANSACTIONS]: [
        this.templateFilterPeriods[EBatchTemplateFilterPeriod.PREBILL],
        this.templateFilterPeriods[EBatchTemplateFilterPeriod.CURRENT],
      ],
    }
  }

  get templateListOptions () {
    const templateList = this.templateType === ETemplateType.MESSAGE
      ? this.messagesList
      : this.lettersList
    const options: Dictionary<string | number>[] = templateList.map(
      (template: ITemplate) => {
        return {
          key: template.id,
          value: template.id,
          content: template.templateName,
        }
      }
    )

    if (this.user.hasPermissionFor(EUserPermissions.MODIFY_TEMPLATES)) {
      const addTemplateTrigger = this.templateType === ETemplateType.MESSAGE
        ? this.ADD_MESSAGE_TRIGGER_VALUE
        : this.ADD_LETTER_TRIGGER_VALUE
      options.push({
        key: addTemplateTrigger,
        value: addTemplateTrigger,
        content: 'Add new +',
      })
    }

    return options
  }

  populateWithDefaultPayers () {
    if (this.template.payers === null) {
      this.template.payers = [] as number[]
      (this.$props.payerTypes as IPayerType[]).forEach(
        (pt) => pt.id && this.template.payers!.push(pt.id)
      )
    }
  }

  beforeMount () {
    this.template = this.$props.templateProp
    this.populateWithDefaultPayers()
  }

  mounted () {
    this.$watch(
      'templateProp',
      () => {
        this.template = this.$props.templateProp
        this.populateWithDefaultPayers()
      },
      { immediate: true }
    )
    this.$watch(
      'payerTypes',
      () => {
        let triggerUpdate = false
        this.template.payers = this.template.payers!.filter(tPayer => {
          const isActive = this.activePayerTypesIds.includes(tPayer)
          if (!isActive) {
            triggerUpdate = true
          }
          return isActive
        })
        triggerUpdate && this.updateTemplate()
      }
    )
  }

  async selectPDFLetterToUpload (item: any): Promise<any> {
    let savedFileName = ''
    const inputPdfEl = this.$refs['statementFile'] as any
    if (!item) {
      inputPdfEl.clear()
      return
    }
    this.isLoadingFile = true
    const res = await this.templateModuleInstance.uploadPDFLetter(item)
    if (!isString(res)) {
      inputPdfEl.clear()
      return
    }

    const regex = /pdf-letters\/(.*)/gm
    savedFileName = res.replace(regex, '$1')
    let fileName = `ChainLetterPdf-${inputPdfEl.selectedFile}`
    const savedTemplate = await this.templateModuleInstance.addTemplate({
      type: ETemplateType.LETTER_PDF,
      level: ETemplateLevel.CHAIN,
      title: inputPdfEl.selectedFile,
      chain: this.chainModuleInstance.chain ? this.chainModuleInstance.chain.id : undefined,
      body: '',
      fileName: savedFileName,
      templateName: fileName
    })
    await this.templateModuleInstance.fetchTemplates({
      sortBy: 'updatedAt',
      sortOrder: ESortOrder.DESC
    })
    inputPdfEl.clear()
    if (!this.template.template) {
      this.template.template = savedTemplate.id
    } else {
      this.$emit('add-template-letter-from-upload', savedTemplate.id)
    }
    this.updateTemplate()
    this.isLoadingFile = false
  }

  selectTemplate (value: number | string) {
    const templateList = this.templateType === ETemplateType.MESSAGE
      ? this.messagesList
      : this.lettersList
    const selectedTemplate = templateList.find(t => t.id === value)
    this.template.type = selectedTemplate ? selectedTemplate.type : this.templateType
    this.updateTemplate()
  }

  updateTemplateFilters () {
    this.template.filterPeriodCutoff = null
    this.template.filterPeriod = null
    this.updateTemplate()
  }

  updateFilterPeriodCutoff (value: number | string) {
    this.template.filterPeriodCutoff = value === '' ? null : Number(value)
    this.updateTemplate()
  }

  updateTemplate () {
    this.$emit('save-template', { ...this.template })
  }
}
